import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function BaristaHeader() {
  return (
    <header className="bg-primary-dark border-b border-white/10 px-4 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl bg-primary flex items-center justify-center">
            <Icon name="ClipboardDocumentListIcon" size={20} className="text-white" />
          </div>
          <div>
            <h1 className="text-white font-bold text-base">Barista Ekranı</h1>
            <p className="text-white/50 text-xs">Gloria Jean's Taksim · Masa 1–15</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-1.5 bg-green-500/20 border border-green-500/30 rounded-full px-3 py-1">
            <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
            <span className="text-green-400 text-xs font-semibold">Canlı</span>
          </div>
          <Link
            href="/personal-profile"
            className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
          >
            <Icon name="UserCircleIcon" size={18} className="text-white" />
          </Link>
        </div>
      </div>
    </header>
  );
}